import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { IHistory, IHistoryChange, IHistoryTab } from 'app/shared/models/history.model';
import { HistoryService } from 'app/shared/services/history.service';
import { take } from 'rxjs';
import { RichTextPreviewComponent } from '../rich-text-preview/rich-text-preview.component';
import { HelperService } from 'app/shared/services/helper.service';
import { UsersService } from 'app/shared/services/users.service';
import { IUser } from 'app/shared/models/users.model';

@Component({
  selector: 'app-case-history',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './case-history.component.html',
  styleUrl: './case-history.component.scss'
})
export class CaseHistoryComponent {
  @Input() tabs: IHistoryTab[] = [];
  @Input() translationPrefix!: string;
  items: IHistory[] = [];
  users: IUser[] = [];
  activeTab!: IHistoryTab;

  opetations = {
    update: 'Update',
    create: 'Create'
  }

  constructor(private historyService: HistoryService, private modalService: NgbModal, public helperService: HelperService, private usersService: UsersService) { }

  ngOnChanges(): void {
    this.getUsers();
    if (this.tabs && this.tabs.length) {
      this.selectActiveTab(this.tabs[0]);
    }
  }

  selectActiveTab(activeTab: IHistoryTab) {
    this.activeTab = activeTab;
    this.getHistoryData();
  }

  getHistoryData() {
    this.historyService.getHistory(this.activeTab.entityId, this.activeTab.value)
      .pipe(take(1)).subscribe((res: IHistory[]) => {
        this.transformHistoryValues(res);
        this.items = res;
      });
  }

  transformHistoryValues(res: IHistory[]) {
    res.forEach((item: IHistory) => {
      item.changesArray.map((c: IHistoryChange) => {
        if (['BookmarkOnly', 'CaseClosureNotifications', 'AllActivityUpdates', 'CustomerEscalatedByWhomInternal'].some(f => f === c.FieldName)) {
          c.OldValue = c.OldValue ? this.helperService.getNameOfUserFromUserJsonString(c.OldValue) : c.OldValue;
          c.NewValue = c.NewValue ? this.helperService.getNameOfUserFromUserJsonString(c.NewValue) : c.NewValue;
        }

        if (['EscalationTeam'].some(f => f === c.FieldName)) {
          c.OldValue = c.OldValue ? this.helperService.getNameOfUserFromUserArrayJsonString(c.OldValue) : c.OldValue;
          c.NewValue = c.NewValue ? this.helperService.getNameOfUserFromUserArrayJsonString(c.NewValue) : c.NewValue;
        }

        if (['ProblemDescription', 'ContainmentSummary', 'ProblemResolutionSummary', 'MsDynamicsReferenceNumber'].some(f => f === c.FieldName)) { ///*** here to add new fields */
          c.htmlField = true;
        }

        if(c.FieldName.includes('Date')) {
          c.dateField = true;
        }
      })
    })
  }

  previewHtml(title: string, content: string) {
    const modalRef = this.modalService.open(RichTextPreviewComponent, {
      modalDialogClass: 'preview-html-modal',
      backdrop: 'static',
      keyboard: false
    });

    modalRef.componentInstance.title = title;
    modalRef.componentInstance.content = content;
  }

  getUsers() {
    this.usersService.users$.subscribe((users: IUser[]) => {
      this.users = users;
    });
  }

  decapitalize(str: string): string {
    return str.charAt(0).toLowerCase() + str.slice(1);
  }

  isFieldHidden(fieldName: string) {
    const hiddenFields: string[] = ['ModifiedAt', 'ModifiedById', 'ImpersonatedById', 'IsActive'];
    return hiddenFields.some(field => field === fieldName);
  }

}
